import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * `<labs-header-bar-right-actions>` is a component that renders one or more `<labs-header-bar-action>`
 */
@Component({
  selector: 'labs-header-bar-right-actions',
  template: '<ng-content select="labs-header-bar-action"></ng-content>',
  styleUrls: ['./header-bar-right-actions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderBarRightActionsComponent {}
